import * as React from "react";

type CompetitorPinIconProps = React.SVGProps<SVGSVGElement> & {
    backgroundColor?: string;
};

const CompetitorPinIcon: React.FC<CompetitorPinIconProps> = ({ backgroundColor = "#5A717A", ...props }) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 31 36" width={31} height={36} {...props}>
            <g filter="url(#m4tehmpk3a)">
                <path
                    d="M25.075 13.525c0 6.102-6.68 12.456-8.923 14.419a1.195 1.195 0 0 1-1.45 0C12.46 25.981 5.78 19.627 5.78 13.525a9.843 9.843 0 0 1 2.826-6.913 9.583 9.583 0 0 1 6.821-2.863 9.583 9.583 0 0 1 6.822 2.863 9.843 9.843 0 0 1 2.826 6.913z"
                    fill={backgroundColor}
                    stroke={backgroundColor}
                    strokeWidth="3.384"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15.921 19.895c-1.236 0-2.326-.263-3.269-.788a5.797 5.797 0 0 1-2.225-2.18c-.526-.926-.788-1.985-.788-3.175 0-1.19.262-2.249.788-3.176a5.797 5.797 0 0 1 2.225-2.18c.943-.525 2.033-.787 3.27-.787 1.034 0 1.962.193 2.78.58.835.37 1.515.888 2.041 1.552.54.665.889 1.445 1.043 2.342h-3.361c-.17-.572-.48-1.005-.928-1.298-.432-.294-.942-.44-1.53-.44-.556 0-1.043.138-1.46.416-.402.279-.711.673-.927 1.183-.217.51-.325 1.112-.325 1.808 0 .695.108 1.298.325 1.808.216.51.525.904.927 1.182.417.279.904.418 1.46.418.588 0 1.098-.147 1.53-.44.449-.294.758-.727.928-1.299h3.361c-.154.896-.502 1.677-1.043 2.341-.525.665-1.205 1.19-2.04 1.577-.82.37-1.747.556-2.782.556z"
                    fill="#fff"
                />
            </g>
            <defs>
                <filter id="m4tehmpk3a" x="0" y="0" width="30.855" height="36" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                    <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                    <feOffset dy="2" />
                    <feGaussianBlur stdDeviation="2" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix values="0 0 0 0 0.176471 0 0 0 0 0.227451 0 0 0 0 0.247059 0 0 0 0.48 0" />
                    <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_1448_10246" />
                    <feBlend in="SourceGraphic" in2="effect1_dropShadow_1448_10246" result="shape" />
                </filter>
            </defs>
        </svg>
    );
};

export { CompetitorPinIcon };
